"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _Colors = require("../00_environment/Colors");

var _Fonts = require("../00_environment/Fonts");

var _bg = _interopRequireDefault(require("../../assets/bg.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Page = function Page(_ref) {
  var _ref$fullScreen = _ref.fullScreen,
      fullScreen = _ref$fullScreen === void 0 ? false : _ref$fullScreen,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "app-wrapper",
    style: {
      width: '100%',
      minHeight: '100vh',
      margin: 0,
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      // backgroundImage: `url(${bg})`,
      // backgroundSize: 'cover',
      // backgroundRepeat: 'no-repeat',
      backgroundColor: _Colors.backgroundColor,
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: "inner-wrapper",
    style: (0, _Fonts.withDefaultFont)({
      width: '100%',
      // minWidth: '100vw',
      flex: '1',
      overflowY: 'auto',
      overflowX: 'hidden',
      position: 'relative',
      // maxWidth: Responsive.onlyTablet.maxWidth,
      marginLeft: 'auto',
      marginRight: 'auto',
      backgroundColor: _Colors.backgroundColor,
      color: _Colors.primaryColor,
      margin: 0,
      padding: 0,
      display: 'flex',
      flexDirection: 'column' // boxShadow: '0px -1px 6px 2px rgba(0,0,0,0.2)',

    })
  }, children));
};

var _default = Page;
exports["default"] = _default;